// 外部系統 deep link 帶資料用的 token redeem API
import { apiFetch, API_BASE_URL } from './client';

export interface PayloadTokenResult {
  flowModelId: string;
  answers: Record<string, string | boolean>;
}

// 用一次性 token 換取已配對好的 answers
// redeem 內部會跑 Gemini structured output，可能超過預設 15s timeout，
// 故拉長到 90s；token 一次性消費，不可重試
export const redeemPayloadToken = async (token: string): Promise<PayloadTokenResult> => {
  const res = await apiFetch(
    `${API_BASE_URL}/payload-tokens/${encodeURIComponent(token)}`,
    {},
    90_000
  );
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Redeem failed: ${res.status}`);
  }
  return res.json();
};
